import React, { PureComponent } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const defaultStyle = {
  height: '2.2rem',
  minHeight: '2.2rem',
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: '5px',
  alignContent: 'center',
  font: '400 1rem Poppins',
  color: '#555'
};

class SelectField extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = selectedOption => {
    this.props.onChange(selectedOption);
  };

  render() {
    const {
      value,
      name,
      options,
      placeholder,
      style = defaultStyle,
      isDisabled = false
    } = this.props;
    const selectStyles = {
      control: base => ({ ...base, ...style }),
      option: base => ({ ...base, font: '400 1rem Poppins' })
    };

    return (
      <Select
        name={name}
        value={value}
        onChange={this.handleChange}
        options={options}
        clearable={false}
        isDisabled={isDisabled}
        className="form__form-group-select"
        placeholder={placeholder}
        styles={selectStyles}
      />
    );
  }
}

const renderSelectField = ({
  input,
  options,
  style,
  label,
  isDisabled,
  placeholder,
  meta: { touched, error }
}) => (
  <div className="form__form-group-input-wrap form__form-group-select-wrap">
    {label && <label>{label}</label>}
    <SelectField
      {...input}
      options={options}
      style={style}
      isDisabled={isDisabled}
      placeholder={placeholder}
    />
    {touched &&
      error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  options: PropTypes.array,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string
};

export default renderSelectField;



// WEBPACK FOOTER //
// ./src/components/formFields/Select.js